import CrmAccountSession from "./model-session"
import CollectionProto from "../../../../data-structures/depricated/collection-proto"

export default class CrmAccountCollectionSession extends CollectionProto<CrmAccountSession> {
    constructor(models: any[]) {
        super(models, CrmAccountSession);
    }

    exportToOptions() {

        let options = _.map(this._models, model=>{
            return {
                label   : model.name,
                value   : model.id
            }
        })

        options = _.sortBy(options, option=>{
            return option.label.toLowerCase()
        })

        return options
    }
}
